import { useState, useEffect } from 'react';

/**
 * VideoSubtitles Component
 * Displays subtitles synced with video playback
 * Positioned at bottom of video container, doesn't block CTAs
 */
export function VideoSubtitles({ videoRef, subtitles, isPlaying }) {
  const [currentCue, setCurrentCue] = useState(null);

  useEffect(() => {
    if (!videoRef?.current || !subtitles?.cues?.length) {
      setCurrentCue(null);
      return;
    }

    const video = videoRef.current;
    
    const updateCue = () => {
      const currentTime = video.currentTime;
      const cue = subtitles.cues.find(
        c => currentTime >= c.start_time && currentTime <= c.end_time
      );
      setCurrentCue(cue || null);
    };

    // Update on timeupdate event
    video.addEventListener('timeupdate', updateCue);
    
    return () => {
      video.removeEventListener('timeupdate', updateCue);
    };
  }, [videoRef, subtitles]);

  if (!currentCue || !isPlaying) return null;

  return (
    <div 
      className="absolute bottom-16 left-0 right-0 px-4 z-10 pointer-events-none"
      data-testid="video-subtitles"
    >
      <div className="bg-black/70 backdrop-blur-sm rounded-lg px-3 py-2 mx-auto max-w-[90%] w-fit">
        <p className="text-white text-sm text-center leading-snug font-medium">
          {currentCue.text}
        </p>
      </div>
    </div>
  );
}

export default VideoSubtitles;
